export const enum ObstShape { Cube = 1, Polygon = 2, Cylinder = 3 }
export const enum ModuleOrientation { Portrait = 'port', Landscape = 'land', Both = 'both'}
export const enum AlertType {success="success", info="info", warning="warning", error="error"}
export const enum EditorControlMode { orbit = 'orbit', pan = 'pan' }
export const enum ScreenShotType { home = 'home', north = 'north', south = 'south', east = 'east', west = 'west', tree = 'tree' }
export const enum ReportType { direct = 'direct', measure = 'measure', site = 'site'}

export const enum EPCStep { 
    None = 'None',
    Lead = 'Lead', 
    Contact = 'Contact', 
    Utility = 'Utility', 
    ReadyForLeadSystem = 'ReadyForLeadSystem',
    Design = 'Design',
    Quote = 'Quote',
 }

export const enum TabName {
    Building = 'building',
    Roof = 'roof',
    Obstruction = 'obstruction',
    Tree = 'tree',
    Modules = 'modules',
    SolarAccess = 'solar-access',
    Irradiance = 'irradiance',
    WhatIf = 'what-if', 
    SurfaceDraw = 'surface-draw',
    CustomImage = 'custom-image',
    EPC = 'epc',
    PackingSlip = 'packing-slip'
}

export const enum SelectType {
    roof = 'roof',
    obst = 'obst',
    tree = 'tree',
    module = 'module',
    sun = 'sun',
    mapCustom = 'mapCustom',
    pathway = 'pathway',
    measure = 'measure',
    surface = 'surface',
    whatIf = 'whatIf',
    epc = 'epc',
    none = 'none',
}

export enum HideObjectType {
    SunVector = 'SunVector',
    GhostObst = 'GhostObst',
    Seltree = 'Seltree',
    GhostTree = 'GhostTree',
    ModuleTexture = 'ModuleTexture',
    WhatIfAllTrees = 'WhatIfAllTrees',
    WhatIfAllObst = 'WhatIfAllObst'
}

export const enum TreeProperty {
    posX = 'posX',
    posY = 'posY',
    delete = 'delete',
    shape = 'shape',
    height = 'height',
    crown_radius = 'crown_radius',
    crown_height = 'crown_height',
    trunk_radius = 'trunk_radius',
}

export const enum ObstProperty {
    angle = 'angle',
    height = 'height',
    length = 'length',
    width = 'width',
    sides = 'sides',
    diameter = 'diameter',
    radius = 'radius',
    shape = 'shape',
    delete = 'delete',
}

export const enum CustomImageProperty {
    scale = 'scale',
    width = 'width',
    height = 'height',
    rotation = 'rotation',
    posX = 'posX',
    posY = 'posY',
    delete = 'delete',
    opacity = 'opacity',
}

export enum CalculationType {
    SHADE = 'shadeCalculations',
    ACCESS_MULTI = 'accessMultipliers',
    IDEAL_MULTI = 'faceIdealApi',
    MODULE_GRAPH = 'moduleGraph',
}

export const enum MeshType {
    Tree = 'tree',
    Roof = 'roof',
    Obst = 'obstruction',
    Wall = 'wall',
    Pathway = 'pathway',
    Setback = 'setback',
    Floor = 'floor',
    Module = 'module',
    ModuleLabel = 'moduleLabel',
    ShadePoint = 'shadePoint',
    Map = 'map',
}

export enum ImageryOptions {
    DEFAULT = 'nearmap',
    GOOGLE = 'google',
    NEARMAP = 'nearmap',
    MAPBOX = 'mapbox',
    CUSTOM = 'custom',
}

export enum EquipmentType {
    Module = "module",
    Inverter = "inverter",
    Optimizer = "optimizer",
    Fastener = "fastener",
    Rail = "rail",
    RackingSystem = "rackingSystem",
    Splice = "splice",
    MidClamp = "mid-clamp",
    EndClamp = "end-clamp",
    MlpeBracket = "mlpeBracket"
}

export const enum EnggSectionType { EL = 'engineering-letter', FEA = 'final-engineering-affidavit' }
export const enum EnggAction { Initial = "Initial", Update = "Update", Reset = "Reset", Refresh = "Refresh", Download = "Download"}

export const enum EditAction {
    TreeShape = 'TreeShape',
    TreeMove = 'TreeMove',
    TreeCreate = 'TreeCreate',
    TreeHeight = 'TreeHeight',
    TreeCrownDiameter = 'TreeCrownDiameter',
    TreeCrownHeight = 'TreeCrownHeight',
    TreeTrunkRadius = 'TreeTrunkRadius',
    GhostTree = 'GhostTree',
    GhostTreeAndCart = 'GhostTreeAndCart',
    ObstMove = 'ObstMove',
    ObstCreate = 'ObstCreate',
    ObstAngle = 'ObstAngle',
    ObstShape = 'ObstShape',
    ObstSides = 'ObstSides',
    ObstHeight = 'ObstHeight',
    ObstLength = 'ObstLength',
    ObstWidth = 'ObstWidth',
    ObstRadius = 'ObstRadius',
    ObstDiameter = 'ObstDiameter',
    GhostObstruction = 'GhostObstruction',
    MaterialChange = 'MaterialChange',
    ModuleLayout = 'ModuleLayout',
    WallHeight = 'WallHeight',
    UpdatePlaneRoof = 'UpdatePlaneRoof',
    TogglePathway = 'TogglePathway',
    MapMove = 'MapMove',
    DrawFace = 'DrawFace',
    DeleteFace = 'DeleteFace',
}